import { ApiBot } from 'api/apiBot/apiBot';
import store, { AppDispatch } from 'store';
import { SET_CONNECTED_BOTS_ACTION } from 'store/slices/pairs_connected_bots/constants';
import { ECexBot, EDexBot } from 'types/bots';
import { EExchange } from 'web3';

export const getPairLinkedBots = async ({
  pairId,
  dispatch,
  exchange,
}: {
  pairId: number;
  dispatch: AppDispatch;
  exchange: EExchange;
}) => {
  const isAdmin = store.getState().auth.isAdmin;

  if (!isAdmin) return;

  try {
    const { isSuccess, data } =
      exchange === EExchange.dex
        ? await ApiBot.getDexLinkedBots({ pairId })
        : await ApiBot.getCexLinkedBots({ pairId });

    if (isSuccess && data) {
      const bots = Object.values(EDexBot).concat(Object.values(ECexBot) as number[]) as number[];
      const connectedBots: Record<EDexBot | ECexBot, boolean> = {} as Record<
        EDexBot | ECexBot,
        boolean
      >;

      for (const value of bots) {
        connectedBots[value as EDexBot | ECexBot] =
          data.items.find(el => el.bot.id === value)?.is_enabled ?? false;
      }

      // Dispatch plain action instead of importing slice directly to keep
      // this helper decoupled from Redux (matches lazy store usage in ApiBot).
      dispatch({
        type: SET_CONNECTED_BOTS_ACTION,
        payload: {
          pairId,
          connectedBots,
        },
      });
    }
  } catch (error) {
    console.log('error: ', error);
  }
};
